import { createFeature, createReducer, on } from '@ngrx/store';

import { EstablishmentType, HotelConfigModel, HotelModel, RoomModel } from '../../models';

import * as HotelActions from './hotel.actions';

export const HOTEL_FEATURE_KEY = 'hotelState';

export interface HotelState {
  hotel: HotelModel | null;
  hotelConfig: HotelConfigModel | null;
  rooms: RoomModel[] | null;
  establishmentType: EstablishmentType | null;
}

export const initialHotelState: HotelState = {
  hotel: null,
  hotelConfig: null,
  rooms: null,
  establishmentType: null,
};

const reducer = createReducer(
  initialHotelState,
  on(HotelActions.setHotel, (state, { hotel }) => ({ ...state, hotel })),
  on(HotelActions.setHotelConfig, (state, { hotelConfig }) => ({
    ...state,
    hotelConfig: {
      ...hotelConfig,
      currency: {
        ...hotelConfig.currency,
        symbol: hotelConfig.currency.symbol + ' ',
      },
    },
  })),
  on(HotelActions.setHotelRooms, (state, { rooms }) => ({ ...state, rooms })),
  on(HotelActions.setEstablishmentType, (state, { establishmentType }) => ({ ...state, establishmentType })),
);

export const hotelFeature = createFeature({
  name: HOTEL_FEATURE_KEY,
  reducer: reducer,
});
